import { createNumberMask } from "text-mask-addons";

const currencySymbols = [
  { code: "IDR", symbol: "Rp" },
  { code: "USD", symbol: "US$" },
  { code: "INR", symbol: "INR" },
];

const getCurrencySymbols = () => {
  return currencySymbols;
};

const getCurrencySymbol = (code) => {
  if (code === "" || code === undefined) {
    return "";
  }
  const indexCureency = currencySymbols.findIndex((row) => row.code === code);

  if (indexCureency > -1) {
    return currencySymbols[indexCureency].symbol;
  } else {
    return code;
  }
};

const formatRupiah = (prefix, angka) => {
  var number_string = angka.replace(/[^,\d]/g, "").toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
  return prefix === undefined ? rupiah : rupiah ? "IDR " + rupiah : "";
};
const formatCurrency = (prefix, number, numberOnly = false) => {
  switch (prefix) {
    case "IDR":
      var number_string = number.toString(),
        split = number_string.split("."),
        restSplit = split[0].length % 3,
        newNumber = split[0].substr(0, restSplit),
        thousands = split[0].substr(restSplit).match(/\d{3}/gi);

      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (thousands) {
        let separator = restSplit ? "." : "";
        newNumber += separator + thousands.join(".");
      }

      newNumber =
        split[1] !== undefined ? newNumber + "," + split[1] : newNumber;
      if (numberOnly === true) {
        return newNumber;
      } else {
        return prefix === undefined
          ? newNumber
          : newNumber
          ? getCurrencySymbol(prefix) + " " + newNumber
          : "";
      }
      break;

    default:
      var number_string = number.toString(),
        split = number_string.split("."),
        restSplit = split[0].length % 3,
        newNumber = split[0].substr(0, restSplit),
        thousands = split[0].substr(restSplit).match(/\d{3}/gi);

      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (thousands) {
        let separator = restSplit ? "," : "";
        newNumber += separator + thousands.join(",");
      }

      newNumber =
        split[1] !== undefined ? newNumber + "." + split[1] : newNumber;
      if (numberOnly === true) {
        return newNumber;
      } else {
        return prefix === undefined
          ? newNumber
          : newNumber
          ? getCurrencySymbol(prefix) + " " + newNumber
          : "";
      }
      break;
  }
};

const formatDB = (angka, suffix = "Rp") => {
  if (angka === "") {
    return 0;
  }

  var number_string = angka.toString(),
    clearSuffix = number_string.replace(suffix, ""),
    clearSpace = clearSuffix.replace(" ", ""),
    clearDecimalpoint = clearSpace.replace(/\./g, ""),
    clearDelimiter = clearDecimalpoint.replace(",", ".");

  return clearDelimiter;
};

const createMaskInput = (prefix, suffix, allowDecimal, intLimit) => {
  return createNumberMask({
    prefix: prefix || "",
    suffix: suffix || "",
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ".",
    allowDecimal: (allowDecimal ? true : false),
    decimalSymbol: ",",
    integerLimit: intLimit,
  });
}

export { getCurrencySymbols, formatCurrency, formatRupiah, formatDB, createMaskInput };
